/**
 * Login Page Component
 *
 * Automatically redirects to Authentik OIDC authentication flow.
 * No user interaction needed - redirect happens immediately on page load.
 */

import { useEffect, useRef } from "react";
import { Spin, Typography } from "antd";

const { Text } = Typography;

export const Login: React.FC = () => {
  const hasRedirected = useRef(false);

  useEffect(() => {
    console.log('[Login] Component mounted, initiating login...');

    // Prevent multiple redirects
    if (hasRedirected.current) {
      console.log('[Login] Already initiated redirect, skipping...');
      return;
    }

    // Mark that we've initiated redirect
    hasRedirected.current = true;

    // Direct redirect to backend auth endpoint (not through Refine)
    const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000';
    console.log('[Login] Redirecting to:', `${apiUrl}/auth/login`);

    // Use a small timeout to ensure the render completes
    setTimeout(() => {
      window.location.href = `${apiUrl}/auth/login`;
    }, 100);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        gap: "20px",
      }}
    >
      <Spin size="large" />
      <Text style={{ color: "white", fontSize: 16 }}>
        Перенаправление на страницу входа...
      </Text>
    </div>
  );
};

